import imagesLoaded from "imagesloaded"
import Isotope from "isotope-layout"
import React from "react"
import { Component } from "react"


export default class IsotopeCards extends Component {

  state = {
    ready: false
  }


  constructor( props ) {
    super( props )
    this.$container = React.createRef();
  }

  componentDidMount() {
    var grid = this.$container
    const $el = document.querySelector( ".masonry-container" )
    imagesLoaded( $el, () => {
      window.setTimeout( () => {
        this.setState( { ready: true } )
        var msnry = new Isotope( $el, {
          itemSelector:    '.grid-item',
          percentPosition: true,
          masonry:         {
            columnWidth: '.grid-sizer'
          }
        } );
      }, 250 )
    } )
  }

  render() {
    const { ready } = this.state
    const { children } = this.props
    return <div className={`IsotopeCards masonry-container ${ready && "ready"}`} ref={this.$container}>
      {children}
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/plugin/CategoryShortcuts/IsotopeCards.js